import { createSlice } from "@reduxjs/toolkit";
import { fetchIndicatorsMinistriesMappingList } from "./indicatorsMappingApi";

interface UsersState {
    ministryIndicators: any[];
    isLoading: boolean;
    error: any;
}

const initialState: UsersState = {
    ministryIndicators: [],
    isLoading: false,
    error: null
}

const indicatorsMinMappingSlice = createSlice({
    name: "indicatorsMapping",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchIndicatorsMinistriesMappingList.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchIndicatorsMinistriesMappingList.fulfilled, (state, action) => {
                state.isLoading = false;
                state.ministryIndicators = action?.payload?.data || [];
            })
            .addCase(fetchIndicatorsMinistriesMappingList.rejected, (state, action) => {
                console.log('error', action.payload)
                state.isLoading = false;
            })
    }
});

export default indicatorsMinMappingSlice.reducer;